import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Task, TasksAddEditService } from 'mojo-tasks';

@Component({
  selector: 'mojo-tasks-list',
  templateUrl: './tasks-list.component.html',
  styleUrls: ['./tasks-list.component.scss'],
})
export class TasksListComponent implements OnDestroy {
  addTaskMode$ = this.tasksAddEditService.isAddModeEnabled$;

  @Input() tasks: Task[];
  @Input() sideDrawerConfiguration;
  @Output() taskCreated = new EventEmitter<Partial<Task>>();
  @Input() totalPages: number;
  @Output() emiterScroll = new EventEmitter<number>();
  @Output() pageReseted = new EventEmitter<boolean>();
  @Input() resetPage = false;
  @Input() width;
  @Output() isAssignOpened = new EventEmitter<boolean>();
  page = 0;

  @ViewChild('tasksList') tasksListElement: ElementRef;

  datePickerOpened = false;

  private sub: Subscription = new Subscription();

  constructor(private store: Store, private tasksAddEditService: TasksAddEditService) {}

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  clickOutside() {
    if (!this.datePickerOpened) {
      this.tasksAddEditService.cancelAnyTaskMode();
    }
  }

  handleDatePickerState(e: boolean) {
    this.datePickerOpened = e;
  }

  onScroll() {
    if (this.resetPage) {
      this.page = 0;
      this.pageReseted.emit(true);
    }
    if (
      this.tasksListElement.nativeElement.offsetHeight +
        this.tasksListElement.nativeElement.scrollTop >=
        this.tasksListElement.nativeElement.scrollHeight &&
      this.page < this.totalPages - 1
    ) {
      this.emiterScroll.emit(++this.page);
    }
  }

  setisAssignOpened(isAssignOpened: boolean) {
    this.isAssignOpened.emit(isAssignOpened);
  }
}
